import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export function QrCard({
  url,
  description = 'Print this code on a thank-you card. It encodes only the customer feedback URL. Download it now; the unique token is not stored after you leave this page.',
  alt = 'QR code for the customer feedback URL',
  filenamePrefix = 'fois-utsavvoice-feedback',
}: {
  url: string;
  description?: string;
  alt?: string;
  filenamePrefix?: string;
}) {
  const [png, setPng] = useState<string>('');
  const [svg, setSvg] = useState<string>('');

  useEffect(() => {
    void QRCode.toDataURL(url, {
      margin: 1,
      width: 240,
      color: { dark: '#2B2723', light: '#F8F3EA' },
    }).then(setPng);
    void QRCode.toString(url, { type: 'svg', margin: 1 }).then(setSvg);
  }, [url]);

  function download(filename: string, contents: string, mime: string): void {
    const blob = contents.startsWith('data:') ? undefined : new Blob([contents], { type: mime });
    const href = contents.startsWith('data:') ? contents : URL.createObjectURL(blob!);
    const anchor = document.createElement('a');
    anchor.href = href;
    anchor.download = filename;
    anchor.click();
    if (blob) {
      URL.revokeObjectURL(href);
    }
  }

  return (
    <div className="mt-6 rounded-none border border-linen bg-cream p-4">
      <h2 className="heading-lg text-crimson">QR code</h2>
      <p className="mt-2 text-sm text-charcoal">
        {description}
      </p>
      {png ? (
        <img
          className="mx-auto mt-4 h-48 w-48"
          src={png}
          alt={alt}
        />
      ) : (
        <p className="mt-4" role="status">
          Preparing QR code…
        </p>
      )}
      <div className="mt-4 flex flex-col gap-2 sm:flex-row">
        <button
          className="btn-secondary"
          type="button"
          disabled={!png}
          onClick={() => download(`${filenamePrefix}.png`, png, 'image/png')}
        >
          Download PNG
        </button>
        <button
          className="btn-secondary"
          type="button"
          disabled={!svg}
          onClick={() => download(`${filenamePrefix}.svg`, svg, 'image/svg+xml')}
        >
          Download SVG
        </button>
      </div>
    </div>
  );
}
